import React from "react";
import { SlideManager } from "components/organisms/CommonUI/SlidePopup/SlideManager";
import DrugLabelSlideContent from "./DrugLabelSlideContent";

/** 우측 슬라이드 패널을 열어 해당 의약품 허가사항을 표시. */
export function openDrugLabelSlide(params: { itemCode: string; productName?: string }) {
  SlideManager.show({
    body: <DrugLabelSlideContent {...params} />,
    width: "800px", // 기존 우측 슬라이드 관례(UnlinkedDrugIdentifications 등). 허가사항은 표/텍스트가 많아 넓게.
    needCloseButton: true,
    direction: "right",
  });
}
